var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-dropdown-container",class:[
    _vm.variant ? `language-dropdown-container--${_vm.variant}` : '',
    _vm.className,
  ]},[_c('p',[_vm._v(_vm._s(_vm.resource["AIAnalyzeChangeLanguageText"]))]),_c('b-dropdown',{staticClass:"language-dropdown",attrs:{"text":_vm.languageItems
        .find((item) => item.key === _vm.language)
        ?.shortTitle?.toUpperCase()}},_vm._l((_vm.languageItems),function(item){return _c('b-dropdown-item',{key:item.id,on:{"click":function($event){return _vm.changeLanguage(item)}}},[_vm._v(_vm._s(item.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }